import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizFocusManager,
  WizTextInput,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';

import { ViewData } from '@wizeoo/akm-common-lib';
import { FreeDataVO } from '@wizeoo/akm-common-lib';
import { FreedataValueVO } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'fdv-code-pop',
  templateUrl: './fdv-code.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreedataValueCodePop extends WizBasePopUp {
  @ViewChild(WizValidationContainerDirective, { read: WizValidationContainerDirective })
  private validationContainer: WizValidationContainerDirective;

  @ViewChild('tiCode', { read: WizTextInput, static: true }) tiCode: WizTextInput;

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super();
  }

  public currentFDV: FreedataValueVO;
  public clone: FreeDataVO;
  public oldCode: string;
  
  private _isValidable: boolean = false;
  public get isValidable(): boolean {
    // activation du bouton de sauvegarde
    return this._isValidable;
  }

  // validation sur enter
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER && this.isValidable) {
      this.validate();
    }
  }

  show() {
    this.clone = this.datas[0];
    this.currentFDV = this.datas[1];
    this.callback = this.datas[2];
    this.oldCode = this.currentFDV.code;

    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;
    this.tiCode.wizValue = this.currentFDV.code;
    // focus du premier champ
    WizFocusManager.getInstance().wizSetFocus(this.tiCode);

    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onModelUpdate);
  }

  onModelUpdate(e: WizEvent): void {

    const errors: WizValidationErrors = this.validationContainer.check(true);
    
    this._isValidable = !errors || errors.length === 0;
    // console.log('validable', this._isValidable, errors);
    this.cdref.markForCheck();
  }

  /**
   * Validateur d'unicité du code / shortCode
   */
   public uniqueFDVCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le _clone est null
      if (!this.currentFDV || this.currentFDV.exist) {
        return null;
      }

      if (this.tiCode.wizValue !== null && this.tiCode.wizValue && this.tiCode.wizValue.length > 0) {
        // CHRONO = mot réservé
        if (this.tiCode.wizValue.toUpperCase() === 'CHRONO') {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }

        // Recherche d'une autre codif avec le même code
        const otherFdv: FreedataValueVO = this.clone.getFreeDataValue(this.tiCode.wizValue.toUpperCase())
 
        // Si une codif existe deja avec le meme code on affiche le message
        if (otherFdv && otherFdv.uid !== this.clone.uid) {
          const temp: WizValidationError = {
            wizError: '$.freedatavalue.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  validate(): void {
    if (this.isValidable) {
      this.callback(this.currentFDV, this.tiCode.wizValue?.toUpperCase());
      this.hide();
    }
  }


  hide() {
    WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE);
    super.hide();
  }
}
